export const isLocal = () => {
  return process.env.VUE_APP_ENV === "local";
};
export const isDev = () => {
  return process.env.VUE_APP_ENV === "dev"; // NODE_ENV is production, but dev cluster
};

export const isStage = () => {
  return process.env.VUE_APP_ENV === "stage";
};

export const isProd = () => {
  return process.env.VUE_APP_ENV === "prod";
};

export const isElectron = () => {
  return window._V6T ? true : false; // VIRTUPET
};

// "확실한 일반 브라우저"(크롬/파이어폭스/엣지/사파리 계열)인가 — /on-air 그린 배경 판별용.
//  기본은 투명(모르는 캡처 앱이 안전하게 동작), 일반 브라우저로 확인될 때만 그린.
//  주의: OBS/PRISM 내장 브라우저(CEF)도 UA에 Chrome/이 포함되므로 방송앱 신호를 "먼저" 배제한다.
export const isPlainBrowser = () => {
  if (typeof window === "undefined") return false;
  if (window.obsstudio) return false; // OBS·PRISM(데스크톱, obs-browser 기반)이 주입
  const ua = navigator.userAgent || "";
  if (/OBS\//.test(ua) || /PRISM/i.test(ua)) return false; // 방송앱 UA (PRISM 모바일 등)
  // 데스크톱/모바일 주요 브라우저 (CriOS/FxiOS = iOS 크롬/파폭)
  return /Chrome\/|Firefox\/|Safari\/|Edg\/|CriOS\/|FxiOS\//.test(ua);
};
